import { Injectable } from '@angular/core';
import { AngularModuleServiceBase } from 'src/shared/services/angular-module-service-base';

@Injectable({
  providedIn: 'root'
})
export class AngularModuleService extends AngularModuleServiceBase {
  constructor() {
    super(true);
  }
}
